var map = {
	"./Abhishek.webp": 9448,
	"./AbhishekSharma.webp": 9088,
	"./Ananya.webp": 1078,
	"./Ansh.webp": 9067,
	"./Anshul.webp": 7796,
	"./Ayush.webp": 7096,
	"./Deepak.webp": 6754,
	"./Harshita.webp": 724,
	"./Ishan.webp": 5908,
	"./Kanishak.webp": 1561,
	"./Neha.webp": 7062,
	"./Pranav.webp": 3729,
	"./Rajesh.webp": 7237,
	"./Shashank.webp": 483,
	"./ShivamKumar.webp": 1770,
	"./Tanisha.webp": 1558,
	"./Ujjawal.webp": 6704,
	"./vardhan.webp": 5087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7605;